module.exports = __webpack_public_path__ + "static/media/hand-back-left-off.f24a6c77.svg";